import { runtimeConfig } from "@/shared/config/runtime-config-loader";

const OIDC_AUTHORITY = runtimeConfig.oidcAuthority;
const OIDC_CLIENT_ID = runtimeConfig.oidcClientId;
const OIDC_SCOPES = runtimeConfig.oidcScopes;

export { OIDC_AUTHORITY, OIDC_CLIENT_ID, OIDC_SCOPES };
